function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { slugify } from '@finect/front-utils/slugify';
import { debounce } from '@finect/front-utils/debounce';
import { cancelablePromise } from '@finect/front-utils/cancelablePromise';
import { X } from '@finect/tabular-icons/x';
import { Small } from '@finect/tabular-core/Small';
import { Flex } from '@finect/tabular-core/Flex';
import { AnswerCount, ResultBox, Results, ResultHeading, CloseSuggestions, ResultItem, ResultItemLink } from './partials';
export var QuestionSuggestion = function (_React$Component) {
  _inherits(QuestionSuggestion, _React$Component);
  var _super = _createSuper(QuestionSuggestion);
  function QuestionSuggestion() {
    var _this;
    _classCallCheck(this, QuestionSuggestion);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "pendingPromises", []);
    _defineProperty(_assertThisInitialized(_this), "state", {
      suggestions: [],
      showSuggestions: false,
      forceHide: false
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      return _this.pendingPromises.map(function (promise) {
        return promise.cancel();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "appendPendingPromise", function (promise) {
      return _this.pendingPromises = [].concat(_toConsumableArray(_this.pendingPromises), [promise]);
    });
    _defineProperty(_assertThisInitialized(_this), "removePendingPromise", function (promise) {
      return _this.pendingPromises = _this.pendingPromises.filter(function (pendingPromise) {
        return pendingPromise !== promise;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "processPromise", function (wrappedPromise) {
      wrappedPromise.promise.then(function (search) {
        if (search) {
          _this.setState({
            suggestions: search.slice(0, 8),
            showSuggestions: true
          });
          if (!_this.props.editor) return;
          _this.props.editor.callbacks = {
            onEscape: _this.forceHideSuggestions,
            onReturn: _this.hideSuggestions
          };
        } else {
          _this.hideSuggestions();
        }
      }).then(function () {
        _this.removePendingPromise(wrappedPromise);
      }).catch(function (errorInfo) {
        if (!errorInfo.isCanceled) {
          _this.removePendingPromise(wrappedPromise);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "fetchSuggestions", debounce(function (searchTerm) {
      return finectAPI({
        version: 'v4',
        path: "search/questions?q=".concat(searchTerm),
        method: 'GET',
        onSuccess: function onSuccess(search) {
          if (search.data.length > 0) return search.data;
          return null;
        }
      });
    }, 300));
    _defineProperty(_assertThisInitialized(_this), "getSuggestions", function (searchTerm) {
      if (searchTerm === '') return _this.setState({
        forceHide: false
      });
      if (_this.state.forceHide) return;
      var wrappedPromise = cancelablePromise(_this.fetchSuggestions(searchTerm));
      _this.appendPendingPromise(wrappedPromise);
      _this.processPromise(wrappedPromise);
    });
    _defineProperty(_assertThisInitialized(_this), "hideSuggestions", function (forceHide) {
      var newState = {};
      newState.showSuggestions = false;
      if (forceHide) newState.forceHide = true;
      _this.setState(newState);
      if (!_this.props.editor) return;
      _this.props.editor.callbacks = {
        onEscape: null,
        onReturn: null
      };
    });
    _defineProperty(_assertThisInitialized(_this), "forceHideSuggestions", function () {
      _this.hideSuggestions(true);
    });
    return _this;
  }
  _createClass(QuestionSuggestion, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.decoratedText !== this.props.decoratedText) {
        this.getSuggestions(nextProps.decoratedText.trim());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        showSuggestions = _this$state.showSuggestions,
        suggestions = _this$state.suggestions,
        forceHide = _this$state.forceHide;
      var children = this.props.children;
      return React.createElement("div", null, children, showSuggestions && !forceHide ? React.createElement(ResultBox, {
        contentEditable: false
      }, React.createElement(ResultHeading, null, "Preguntas que quiz\xE1 resuelvan tu duda:", React.createElement(CloseSuggestions, {
        onClick: this.forceHideSuggestions
      }, React.createElement(X, {
        size: "18"
      }))), React.createElement(Results, null, suggestions.map(function (suggestion, index) {
        return React.createElement(ResultItem, {
          key: index
        }, React.createElement(Flex, {
          align: "flex-start"
        }, React.createElement(AnswerCount, {
          isSolved: 0
        }, suggestion.stats.answers && suggestion.stats.answers.length || 0), React.createElement(ResultItemLink, {
          href: "/preguntas/".concat(suggestion.id, "/").concat(slugify(suggestion.title)),
          target: "_blank"
        }, suggestion.title)), suggestion.stats.votes > 0 ? React.createElement(Small, {
          light: true
        }, "(", suggestion.stats.votes, " votos)") : null);
      }))) : null);
    }
  }]);
  return QuestionSuggestion;
}(React.Component);